import { Api } from "./Api";
import axios from "axios";
import { Trajet } from "../models/Trajet";
import Distance = Trajet.Distance;
import moment from "moment";
import { DateUtils } from "../utils/DateUtils";

export class DistanceApi extends Api {
    constructor() {
        super("distance");
    }

    getAll(params?: Object): Promise<Array<Distance>> {
        return this.getResources(params).then(function (response) {
            let res: Array<Distance> = [];
            if (response.data && response.data.data) {
                res = _.map(response.data.data, function (d) {
                    return new Distance(d);
                });
            }
            return res;
        });
    }

    save(distance: Distance, params?: Object): Promise<Distance> {
        return super.saveResource(distance, params).then(function (response) {
            return new Distance(response.data.data);
        });
    }

    refreshDistance(id: number): Promise<Distance> {
        return axios
            .get(this.apiUrl + id + "/refresh")
            .then(function (response) {
                return new Distance(response.data.data);
            });
    }
}
